G.BoardCollectCells = function(board, lvl) {
  Phaser.Group.call(this, game);

  this.board = board;
  this.position = board.position;
  this.scale = board.scale;
  this.lvlData = lvl;

  this.ccs = [];

  if (lvl.collectCells) {
    this.init(lvl.collectCells);
  }

};
 
G.BoardCollectCells.prototype = Object.create(Phaser.Group.prototype);

G.BoardCollectCells.prototype.init = function(optCollectCells) {
  collectCells = G.Utils.defined(optCollectCells, []);

  collectCells.forEach(function(cc) {
    this.addCollectCells(cc.x, cc.y);
  }, this);

  G.sb("onCollectableTaskFinished").add(function(type) {
    if (type === "goalCandy") {
      this.hide();
    }
  }, this);

  G.sb("onGoalAchieved").add(this.hide, this);
};

G.BoardCollectCells.prototype.hide = function() {
  if (this.alpha !== 1) return;
  game.add.tween(this)
    .to({alpha: 0}, 300, Phaser.Easing.Sinusoidal.In, true);
};

G.BoardCollectCells.prototype.addCollectCells = function(cellX, cellY) {
  if (this.getCollectCell(cellX, cellY)) return;

  var x = cellX * this.board.tilesize;
  var y = cellY * this.board.tilesize;
  var cc = G.makeImage(x, y, "collect_cell_2", 0, this);
  cc.cellX = cellX;
  cc.cellY = cellY;
  this.ccs.push(cc);
};

// editor

G.BoardCollectCells.prototype.editorChangeCC = function(cellX, cellY) {
  var matchingCC = this.getCollectCell(cellX, cellY);

  if (matchingCC) {
    this.removeCollectCell(cellX, cellY);
  } else {
    this.addCollectCells(cellX, cellY);  
  }

  this.lvlData.collectCells = this.editorExport();
};

G.BoardCollectCells.prototype.removeAllCollectCells = function() {
  while (this.ccs.length > 0) {
    var cellToRemove = this.ccs[0];
    this.removeCollectCell(cellToRemove.cellX, cellToRemove.cellY);
  }
  this.lvlData.collectCells = this.editorExport();
};

G.BoardCollectCells.prototype.removeCollectCell = function(cellX, cellY) {
  var cc = this.getCollectCell(cellX, cellY);
  if (cc) {
    cc.destroy();
    this.ccs.splice(this.ccs.indexOf(cc), 1);
  }
};

G.BoardCollectCells.prototype.getCollectCell = function(cellX, cellY) {
  return this.ccs.find(function(cc) {
    return cc.cellX === cellX && cc.cellY === cellY;
  });
};

G.BoardCollectCells.prototype.editorExport = function() {
  if (this.ccs.length === 0) {
    return null;
  } else {
    return this.ccs.map(function(cc) {
      return {x: cc.cellX, y: cc.cellY};
    });
  }
};